mutation ArchiveEngagements($workspaceId: ID!, $ids: [ID]!) {
  archiveEngagements(workspaceId: $workspaceId, ids: $ids)
}
